// extracted by mini-css-extract-plugin
module.exports = {"root":"Error_root__PCBDN","title":"Error_title__WvKRS"};